import type { SkyPhase } from '@iqrapath/shared'

/** Stars: deterministic positions (no layout shift between renders), twinkle via CSS. */
const STARS = Array.from({ length: 34 }, (_, i) => ({
  left: (i * 37.7 + 5) % 100,
  top: (i * 23.3) % 58,
  delay: ((i * 0.73) % 3).toFixed(2),
  size: 1.5 + (i % 3) * 0.7,
}))

const STAR_COUNT: Record<SkyPhase, number> = { subuh: 14, siang: 0, maghrib: 0, isya: 34 }

/** Sky gradient + stars for the 4 phases. Pure decoration (aria-hidden); parents set `data-phase` for the gradient. */
export function SkyBackdrop({ phase }: { phase: SkyPhase }) {
  return (
    <div className="sky" data-phase={phase} aria-hidden="true">
      {STARS.slice(0, STAR_COUNT[phase]).map((s, i) => (
        <i key={i} className="star" style={{ left: `${s.left}%`, top: `${s.top}%`, animationDelay: `${s.delay}s`, width: s.size, height: s.size }} />
      ))}
    </div>
  )
}
